import { useBootstrap } from './useBootstrap.mjs';

const useProjectName = ()=>{
    return useBootstrap().projectName ?? '';
};

export { useProjectName };
//# sourceMappingURL=useProjectName.mjs.map
